module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "ch3",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "Chap-Title-ct",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "27",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cn"
  }, [_vm._v("3.")]), _vm._v(" IT’S NOT WHAT YOU KNOW …")])])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "Chap-Epigraph-non-verse-cepi"
  }, [_c('i', [_vm._v("The only source of knowledge is experience.")])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Epigraph-Source-ceps"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—ALBERT EINSTEIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "cic"
  }, [_vm._v("I")]), _vm._v("t’s who knows "), _c('i', [_vm._v("you")]), _vm._v(" that counts. From the autumn of 1891 when Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" reached Georgetown University in Washington, D.C.,"), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-113",
      "id": "footnote-113-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" he made it his business to be well known. Throughout that first, important freshman year, he sensed not only whom he should befriend but also which activities should propel him to the forefront of the student body’s collective mind. He decided to make his mark in sports, and the preeminent sport among young men of the upper classes was tennis.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Although he excelled at tennis and played a decent game of squash, he was not remotely what his fellow students could call sporty. That said, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" took charge of the tennis association and managed the baseball team. By the autumn term of his sophomore year, he was winning coveted tennis titles in both men’s singles and doubles. He was a finalist in Washington’s District Tennis Tournament in both the men’s singles and doubles in October 1892;"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-1",
      "id": "notes-ch3_1",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" and in July 1894 he came in second in the Seabright tourney in New Jersey."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-2",
      "id": "notes-ch3_2",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "28",
      "id": "pg_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" took up the family interest in editorship and became the first student president of Georgetown’s athletic association, the Yard, which organized the university’s intercollegiate and intramural sports fixtures. Having a participating student rather than a Jesuit faculty member as its leader made it a dynamic force. Given Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s hunger to succeed, he played an active role in its transformation."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-3",
      "id": "notes-ch3_3",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])]), _vm._v(" As its president he discovered he was a natural advocate in publicity, scheduling, fund-raising, and controlling the finances for the association.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" worked alongside his good college friend, the dashing and wealthy Robert J. Collier, son of the publishing magnate Peter Fenelon Collier. Robert had light-brown hair fashionably parted in the middle and was around six feet in height, but stood as tall as if he owned the world. It was his demeanor, his way with words, his love of aviation, horseback riding, and yachting, rather than his average looks that made him swashbuckling. Collier was a first-generation American and a Catholic, like Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(", but his family came from County Carlow in Ireland.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Publishing was in the Collier family blood too. Fenelon Collier had started out publishing books dedicated to the Roman Catholic market in the United States; however, he made his real fortune in publishing encyclopedias and popular novels through the Collier’s Library. With so many points of similarity except money, it is little wonder that Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" and Robert became fast friends. Together they took on the duties of editing the "), _c('i', [_vm._v("Georgetown College Journal")]), _vm._v(", and in their final year, Robert became its editor in chief. The pair also shared a love of music, and Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was reported in the "), _c('i', [_vm._v("College Journal")]), _vm._v(" as playing the flute, “appealing … to the most musical audience.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-4",
      "id": "notes-ch3_4",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])]), _vm._v(" When Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s father, William, died on April 7, 1893, Collier placed the obituary notice in the "), _c('i', [_vm._v("College Journal")]), _vm._v(" on behalf of his friend."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-5",
      "id": "notes-ch3_5",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])]), _vm._v(" Chances are that Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was relieved by his loss.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Graduating in June 1894, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" had won a distinction in rational philosophy and mathematics and was selected to deliver the bachelor’s oration. This scholastic specialism along with his natural abilities as a promoter and editor would become the corner"), _c('span', {
    attrs: {
      "aria-label": "29",
      "id": "pg_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("stones of his future life. Collier read the class poem in a deep, mellifluous voice at the graduation ceremony and won a prize for the most scholarly contributions to the "), _c('i', [_vm._v("College Journal")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-6",
      "id": "notes-ch3_6",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])]), _vm._v(" After graduation the friends parted company. Collier went on to Harvard for a year, then spent another year at Oxford University in England before joining his father’s publishing firm. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" remained at Georgetown for another year to earn a master’s degree with a view to going into the law. It was only in June 1895 that Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" returned to St. Louis, hoping to attend George Washington University’s law school that fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Luck would intervene. After a year at law school, in the summer of 1897, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was asked to help out the printers’ firm in which the family had invested some two thousand dollars. After a detailed study, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" developed a plan. He would travel throughout the South and Midwest to sell advertising for the St. Louis Exhibition."), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-112",
      "id": "footnote-112-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" Its numerous booths sold wine, beer, and various delicacies. There were mechanical, agricultural, and floral halls; a Gothic fine arts hall; and a three-story-high wire “gallinarium,” or Chicken Palace. Horseracing, with its own grandstand and jockey club, provided popular entertainment. With such glittering prizes for advertisers, and Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s enthusiasm for his task, the printers were saved."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-7",
      "id": "notes-ch3_7",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])]), _vm._v(" He had demonstrated to his own satisfaction an understanding of the interrelationship between printing, publishing, subscriptions, and advertising.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("When Collier visited his friend that same summer, he was impressed by Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s approach to advertisers. On returning to New York, Collier, hands planted firmly but nonchalantly in his trouser pockets (as he would do when he was determined to get his way), asked his father if Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" could join him at their failing magazine, "), _c('i', [_vm._v("Collier’s Weekly")]), _vm._v(". Fenelon Collier thought Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was an up"), _c('span', {
    attrs: {
      "aria-label": "30",
      "id": "pg_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("standing and clever young man and agreed. Besides, they had nothing to lose. Correspondence between Collier and Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" ensued. Laying on the charm, Collier said he couldn’t promise him much, only twelve dollars a week, but how would that take care of Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s family? he asked disingenuously."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-8",
      "id": "notes-ch3_8",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])]), _vm._v(" He knew he had dangled an irresistible carrot at Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(".")])]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("What risks would Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" run by accepting Collier’s offer? He was no impetuous youth, given to whims or fancies like his father. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" studied "), _c('i', [_vm._v("Collier’s")]), _vm._v(" history. Founded in 1888 by Peter Fenelon Collier, "), _c('i', [_vm._v("Collier’s Weekly")]), _vm._v(" was born out of "), _c('i', [_vm._v("Collier’s Once a Week: An Illustrated Weekly Newspaper")]), _vm._v(". Its success rested comfortably on the popular book sets by fashionable authors sold on the installment plan. "), _c('i', [_vm._v("Collier’s Once a Week")]), _vm._v(" sold for seven cents and proclaimed that it was a “magazine of fiction, fact, sensation, wit, humor, news.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-9",
      "id": "notes-ch3_9",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])]), _vm._v(" It attracted big-name writers of the day like H. Rider Haggard. There was a “Woman’s World” column; the de rigueur social column, called “Social Silhouettes”; a theater lowdown; and a humor feature. Under the editorship of a young journalist, Nugent Robinson, "), _c('i', [_vm._v("Once a Week")]), _vm._v(" grew to a circulation of 250,000, making it one of the top-selling American weeklies of its day."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-10",
      "id": "notes-ch3_10",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])]), _vm._v(" When Robinson left "), _c('i', [_vm._v("Collier’s")]), _vm._v(" in 1892, a succession of newspaper editors (notably from "), _c('i', [_vm._v("The New York Herald")]), _vm._v(" and "), _c('i', [_vm._v("The New York World")]), _vm._v(") made "), _c('i', [_vm._v("Once a Week")]), _vm._v(" a slightly breezier version of "), _c('i', [_vm._v("Harper’s Weekly")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-11",
      "id": "notes-ch3_11",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("In 1895, when Robert Collier returned from Europe to take things in hand, one of the first things he did was to change the name to "), _c('i', [_vm._v("Collier’s Weekly: An Illustrated Journal")]), _vm._v(". The earlier version was a mass-market publication, sold inexpensively, and crusaded for social reform. Its investigative journalism was highly respected and aimed at the middle classes. Its annual advertising revenue was around five thousand dollars."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-12",
      "id": "notes-ch3_12",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])]), _vm._v(" While Collier appreciated the earlier successes of the magazine, he also knew its popularity was a by-product of the Collier’s Library. So it came as no surprise that circulation declined in the early-to-mid-nineties. Society was changing rapidly, and readers were eager for news, pub"), _c('span', {
    attrs: {
      "aria-label": "31",
      "id": "pg_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("lic affairs, and society columns as well as understanding the new photographic arts. Soon his weekly would become a leader in the new halftone news picture. But Collier did not step into his role a fully formed editor in chief, and Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" knew it. In Collier’s own words, “I had just come from Harvard with the idea that popular journalism needed a little true literary flavor. I showed my judgment of the public taste by ordering a serial story by Henry James ["), _c('i', [_vm._v("The Turn of the Screw")]), _vm._v("]. The illustrations were by John La Farge, and I have never yet discovered what either the story or the pictures were about.”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-13",
      "id": "notes-ch3_13",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("What Collier needed was a young man with a vision similar to his own. A man who shared his love of music and had a deep sense of business ethics, even if that man wasn’t particularly an early aviation enthusiast like Collier."), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-111",
      "id": "footnote-111-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" He needed a man he could trust—a man who could sniff out the advertisers for his new-look magazine. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" had proved himself after graduation in saving the family’s investment through an innovative approach to advertising, and Collier trusted him unreservedly. He knew Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" would understand the need to back his vision of "), _c('i', [_vm._v("Collier’s Weekly")]), _vm._v(" as a magazine that sought to appeal to the college-educated man, without excluding women."), _c('sup', [_c('span', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/footnotes#footnote-110",
      "id": "footnote-110-backlink",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Collier had won the debating medal at Georgetown. His ability to persuade was impressive, and he knew it. So it came as no surprise when, in what may seem an act of blatant rebellion straight out of William Nast’s bag of tricks, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" accepted his friend’s offer. Not only had Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" enjoyed the experience of selling advertising for a “quality” publication and saving an investment for the family that summer, but he also recognized that the law, "), _c('span', {
    attrs: {
      "aria-label": "32",
      "id": "pg_32",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("frankly, was not for him. Besides, Collier had two things Nast lacked: tremendous popularity as a result of his “gift of the gab,” and a pedigree that was as valued in Newport, Rhode Island, society as it was in New York’s. With barely more than the clothes on his back, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" joined Collier in Manhattan. He was twenty-four years old, reserved, but had already acquired his persona of elegance. Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" knew that New York afforded untold opportunities for a man on the make—and he was confident that alongside Collier the risk of failure was minimal.")])]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" was well aware that selling advertising for a failing national magazine was a daunting project. From 1885 to 1905—that double decade of phenomenal change—Europe and North America underwent unprecedented transformations and challenges industrially, financially, politically, socially, and culturally. European empires were challenged; American cities grew beyond all reckoning. The American West and South progressed and even outstripped growth in the powerhouse North. Revolutionary inventions—including labor-saving devices, improvements in communication, enhanced entertainment, and modern modes of transport—gave birth to new industries. Europeans, Asians, and South Americans who saw little hope in the countries of their birth immigrated to the United States and Canada—"), _c('i', [_vm._v("plus ça change")]), _vm._v("—giving rise to what was seen by many as an “immigration crisis.” Radical ideas shaped new political movements that transformed the social order. Shifting religious beliefs spurred by revolutions in education added to the most dramatic change of all to society: the emancipation of women.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Magazines were seen as the popular informers and interpreters of this ever-changing contemporary world. Collier wanted his journal to be the best: improving illustration, hiring the best authors for short stories (it was the heyday of that literary form, after all), and writing about things that mattered to his readers."), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-14",
      "id": "notes-ch3_14",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])]), _vm._v(" To achieve that goal Collier raised the price of the journal to ten cents. It was Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s job to attract national advertisers whose products "), _c('span', {
    attrs: {
      "aria-label": "33",
      "id": "pg_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("would be sold with integrity and no false promises. In an age before national legislation regarding truth in advertising, it became their unique selling point.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Granted, advertising the newfangled typewriter like the Caligraph or the Remington might be desirable, but surely it would be better for Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" to aim to get the account of the eight-dollar Smith-Premier Hammond?"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-15",
      "id": "notes-ch3_15",
      "role": "doc-noteref"
    }
  }, [_vm._v("15")])]), _vm._v(" It would be trickier to assess if the “W. L. Douglas $3 Shoe for Gentlemen” was of sufficient quality, or if Mrs. Pinkham’s portrait advertising “Vegetable Compound for Female Complaints” could live up to Collier’s exacting requirements. And what about Royal Baking Powder’s “Absolutely Pure” slogan? Was it better than Dr. Price’s Cream Baking Powder or its other competitors? And what about Durkee’s Salad Dressing being “Unequalled for Excellence,” or Armour’s Extract of Beef claiming to produce “That Feeling of Contentment”?"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-16",
      "id": "notes-ch3_16",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])]), _vm._v(" While "), _c('i', [_vm._v("Collier’s Weekly")]), _vm._v(" was not responsible for the advertisements placed, Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(" knew that readers would nonetheless associate Collier’s with any advertisers making false claims.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("So Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v(", with his methodical approach, analyzed what other good general or “class” publications did. “Class” in this sense did not mean stylish or sophisticated, but rather publications that aimed at a well-defined socioeconomic group. In Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s own words a class publication was “nothing more or less than a publication that looks for its circulation "), _c('i', [_vm._v("only")]), _vm._v(" from those having in common a certain characteristic marked enough to group them into a class.… The publisher, the editor, the advertising manager and the circulation man must conspire not only to get "), _c('i', [_vm._v("all")]), _vm._v(" their readers from one particular class to which the magazine is dedicated, "), _c('i', [_vm._v("but rigorously to exclude all others")]), _vm._v(" [emphasis in original].”"), _c('sup', [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch3#notes-ch3-17",
      "id": "notes-ch3_17",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("To Cond"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("’s mind, the question remained: Did "), _c('i', [_vm._v("Collier’s Weekly")]), _vm._v(" seek to be a general magazine or a class publication?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba559e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 87
// module chunks = 0